import XlsDownload from "@dana/Icons/XlsDownload";
import { exportOpenOrders } from "@dana/Services/DanaOrderRelatedService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { BackorderResponse, SoldToAddress } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// --- Props Interface ---
interface OpenOrderDetailsHeaderProps {
    openOrders: BackorderResponse;
}

const mapStateToProps = (state: ApplicationStateDana) => {
    const session = getSession(state);
    return {
        soldto:
            session?.properties?.soldToAddress &&
                session?.properties?.soldToAddress !== "" &&
                session?.properties?.soldToAddress !== undefined
                ? (JSON.parse(session?.properties?.soldToAddress) as SoldToAddress)
                : undefined,
    }
};


type Props = OpenOrderDetailsHeaderProps &
    ReturnType<typeof mapStateToProps> &
    HasToasterContext;

// --- Styles Interfaces and Objects ---
export interface OpenOrderDetailsHeaderStyles {
    gridContainer?: GridContainerProps;
    searchGridItem?: GridItemProps;
    exportToExcelGridItem?: GridItemProps;
    searchInputWrap?: InjectableCss;
    modal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const OpenOrderDetailsHeaderStyles: OpenOrderDetailsHeaderStyles = {
    gridContainer: {
        gap: 0,
    },
    searchGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    exportToExcelGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            justify-content: flex-end;
            align-items: center;
        `,
    },
    modal: {
        size: 1140,
        sizeVariant: "large",
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
};

const styles = OpenOrderDetailsHeaderStyles;

// --- Component Definition ---
const OpenOrderDetailsHeader: FC<Props> = ({ openOrders, soldto, toaster }) => {

    const handleExportButtonClick = () => {
        toaster.addToast({
            body: translate("Your request received successfully and is being processed."),
            messageType: "info",
        });
        
        exportOpenOrders(soldto?.CustomerSequence || "");
    };

    return (
        <StyledWrapper>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.searchGridItem}></GridItem>
                <GridItem {...styles.exportToExcelGridItem}>
                    {openOrders !== undefined && openOrders?.backorders !== undefined && (
                        <Link onClick={() => handleExportButtonClick()}>
                            {" "}
                            <Icon src={XlsDownload}></Icon>
                        </Link>
                    )}
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};
export default connect(mapStateToProps)(withToaster(OpenOrderDetailsHeader));
